import styles from "./Banner.module.css";

type BannerProps = {
  message: string;
};

const Banner = ({ message }: BannerProps) => {
  return (
    <div className={styles.banner}>{message}</div>
  );
};

export default Banner;
